module.exports = __webpack_public_path__ + "img/拓展店长.d911d312.svg";